export const ADD_INSTRUCTOR_HEADER = 'Add Instructor'
export const ADD_INSTRUCTOR_HELPER =
  'People you add can access your class and mark lessons done.'
export const ADD_INSTRUCTOR_EMAIL_LABEL = 'Add email address'
export const ADD_INSTRUCTOR_PEOPLE_LABEL = 'People with access:'
export const ADD_INSTRUCTOR_CANCEL = 'Cancel'
export const ADD_INSTRUCTOR_SUBMIT = 'Share'
export const ROLE_OWNER = 'Owner'
export const ROLE_CO_TEACHER = 'Co-teacher'
